import { VolopAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainVolopsSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainVolopSearchRouteData = {
  lang: UserLocale;
  q?: string;
  radius?: number | 'auto' | null;
  filters?: VolopAlgoliaApiQueryFilters;
};

export function getMainVolopsSearchRoutePath(data: MainVolopSearchRouteData) {
  const { lang, filters, q, radius } = data;

  const segment = HOME_PAGE_SLUGS.VOLOP[lang];

  const queryParams: Record<string, unknown> = {};
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;

  if (filters) {
    // Merge basic and filter-derived query parameters
    Object.assign(queryParams, transformSearchFiltersToQueryParams(filters));
  }

  return mainVolopsSearchRouteReference.with({ lang, segment, ...queryParams });
}
